import { render, staticRenderFns } from "./chicks.vue?vue&type=template&id=dcd2b908"
import script from "./chicks.vue?vue&type=script&lang=js"
export * from "./chicks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports